/**
 * Created by jonas on 2020-03-18.
 */
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {FITHSlideShowPage} from "./FITHSlideShowPage";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {FireInTheHole} from "../FireInTheHole";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class FITHIntroConfig implements GameIntroViewConfig {

    public colors: GameIntroColors = {
        slideShowColors: {
            backgroundColor: 0x000000, //Default 0x000000
            backgroundAlpha: 0.4, //Default 0.4
            bulletColor: 0xffffff, //Default 0xffffff

        },
        stampColor: 0xFFFFFF
    };

    public stampConfig: StampConfig = {
        xBomb: true,
        volatility: Volatility.EXTREME
    };

    public background: PIXI.Container;
    public borderBottom: PIXI.Container;
    public borderTop: PIXI.Container;
    public logo: PIXI.Container;
    public pages: SlideShowPage[];

    constructor() {
    }

    public init(): Promise<GameIntroViewConfig> {

        const fontLoader = new FontLoader(NolimitApplication.resourcePath);
        fontLoader.add(OpenSans.ITALIC_600);
        fontLoader.add(OpenSans.NORMAL_300);
        fontLoader.add(OpenSans.NORMAL_400);
        fontLoader.add(OpenSans.NORMAL_700);

        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("introBg", "resources/images/introBackground.jpg");
        imgLoader.add("introDiv", "resources/images/Intro_Divider.png");
        imgLoader.add("feature1", "resources/images/intro_feature1.png");
        imgLoader.add("feature2", "resources/images/intro_feature2.png");
        imgLoader.add("feature2_US","nolimit/screens/images/pageImage_3_US.png");
        imgLoader.add("feature3", "resources/images/intro_feature3.png");
        imgLoader.add("logo", "resources/images/introLogo.png");
        imgLoader.add("bgTrolley", "resources/images/trolly.png");

        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    private initGraphics(): void {
        this.background = new PIXI.Container();

        const bgSprite: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBg"));
        bgSprite.anchor.set(0.5);

        const bgTrolley: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("bgTrolley"));
        bgTrolley.anchor.set(0.5);
        bgTrolley.position.set(208, 567);

        this.background.addChild(bgSprite, bgTrolley);

        this.borderTop = new PIXI.Container();
        const topSprite: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
        topSprite.anchor.set(0.5, 0.46);
        this.borderTop.addChild(topSprite);

        this.borderBottom = new PIXI.Container();
        const bottomSprite: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
        bottomSprite.rotation = Math.PI;
        bottomSprite.anchor.set(0.5, 0.46);
        this.borderBottom.addChild(bottomSprite);

        this.logo = new PIXI.Container();
        const logoSprite: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("logo"));
        logoSprite.anchor.set(0.5);
        this.logo.addChild(logoSprite);

        const winUpToText: string = SlotGame.api.translations.translate("WIN UP TO") + " 60 000 X",
            winUpToTextItem: PIXI.Text = new PIXI.Text(winUpToText, new PIXI.TextStyle({
                fill: "#fff",
                fontFamily: "Arial",
                fontSize: 36,
                fontWeight: FontWeight.BOLD,
                stroke: "#7d4b2e",
                strokeThickness: 4
            })),
            page1: FITHSlideShowPage = new FITHSlideShowPage([ImgLoader.getImgTexture("feature1")]);

        winUpToTextItem.anchor.set(0.5);
        winUpToTextItem.y = 150;
        Helper.shrinkTextWidth(winUpToText, winUpToTextItem, 700);
        page1.addChild(winUpToTextItem);

        this.pages = [];
        this.pages.push(page1);

        if (FireInTheHole.api.gameClientConfiguration.isSet) {
            if (!FireInTheHole.api.gameClientConfiguration.showLowProbabilityGfx) {
                winUpToTextItem.visible = false;
                this.pages.push(new FITHSlideShowPage([ImgLoader.getImgTexture("feature2_US"), ImgLoader.getImgTexture("feature3")]))
            }else{
                this.pages.push(new FITHSlideShowPage([ImgLoader.getImgTexture("feature2"), ImgLoader.getImgTexture("feature3")]))
            }
        } else {
            FireInTheHole.api.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                if (!FireInTheHole.api.gameClientConfiguration.showLowProbabilityGfx) {
                    winUpToTextItem.visible = false;
                    this.pages.push(new FITHSlideShowPage([ImgLoader.getImgTexture("feature2_US"), ImgLoader.getImgTexture("feature3")]))
                }else{
                    this.pages.push(new FITHSlideShowPage([ImgLoader.getImgTexture("feature2"), ImgLoader.getImgTexture("feature3")]))

                }
            });
        }


    }
}